module.exports = __webpack_public_path__ + "c5129fdc3a872134f44086008655e4b2.png";